import { render, staticRenderFns } from "./NovidadesTimelineView.vue?vue&type=template&id=d6431908&scoped=true&"
import script from "./NovidadesTimelineView.vue?vue&type=script&lang=js&"
export * from "./NovidadesTimelineView.vue?vue&type=script&lang=js&"
import style0 from "./NovidadesTimelineView.vue?vue&type=style&index=0&id=d6431908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6431908",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
